// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__334tP","additionalInfo":"AgreementModal_additionalInfo__1UC_q"};